import * as ng from 'angular';

export const AddIconBeforePlaceholder = () => (<angular.IDirective>{

    restrict: 'A',
    scope: {
        'iconClass': '@',
        'iconSize': '@'
    },
    link: (scope: ng.IScope, element: JQuery, attrs: any) => {
        ng.element(document).ready(() => {
            element.closest('span').find('.ui-select-placeholder');
        });
    }
});



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/commons/directives/add-icon-before-placeholder/add-icon-before-placeholder.directive.ts